import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ScrapCarsFaq from "./component";

const mapStateToProps = ({
    scrapCars: {
        cmsData: { faqList, faqTitle }
    }
}) => ({
    faqList, faqTitle
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ScrapCarsFaq);
